var $ec131bb73fe23e70$exports = {};
$ec131bb73fe23e70$exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};


export {$ec131bb73fe23e70$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
